import { connect } from 'react-redux'

import selectors from '../../duck/selectors'
import InboxContent from './InboxContent.component'

const mapStateToProps = (state): any => {
  const messages = selectors.getMessages(state)
  const messagesError = selectors.getMessagesError(state)
  const messagesIsLoading = selectors.getMessagesIsLoading(state)
  const messagesHasLoaded = selectors.getMessagesHasLoaded(state)

  return {
    messages,
    messagesError,
    messagesIsLoading,
    messagesHasLoaded,
  }
}

export default connect(mapStateToProps)(InboxContent)
